import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './Carousel.scss';
import RightArrow from './SVG/RightArrow';
import LeftArrow from './SVG/LeftArrow';

const Carousel = ({ children }) => {
  const sliderRef = useRef();
  const settings = {
    className: 'center',
    // centerMode: true,
    infinite: true,
    // centerPadding: '60px',
    slidesToShow: 1,
    speed: 500,
    rows: 1,
    slidesPerRow: 1,
    dots: true,
    arrows: false,
    appendDots: dots => (
      <div
        className="carousel__controls"
        style={{
          borderRadius: '1rem',
          padding: '1rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <button
          onClick={() => sliderRef.current.slickPrev()}
          className="carousel__control carousel__control--prev"
        >
          <LeftArrow />
        </button>
        <ul style={{ margin: '0 3.6rem', display: 'flex' }}> {dots} </ul>
        <button
          onClick={() => sliderRef.current.slickNext()}
          className="carousel__control carousel__control--right"
        >
          <RightArrow />
        </button>
      </div>
    ),
  };
  return (
    <div className="carousel">
      <Slider ref={sliderRef} {...settings}>
        {children}
      </Slider>
    </div>
  );
};
export default Carousel;
